import React from 'react'
import StatusColumn from 'src/common/utils/TableColumnIcons/StatusColumn'

export const DateColumnFormat = (value, row, rowIndex) => {
  return (
    <>
      <StatusColumn value={value} color="primary" />
    </>
  )
}
